import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import Header from "../components/Header";
import Footer from "../components/Footer";
import getDomainDetails from "../config/domainDetails";

function Contact() {

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        subject: "",
        message: ""
    });

    const [loading, setLoading] = useState(false);
    const [domainDetails, setDomainDetails] = useState(null);
    const [contactLoading, setContactLoading] = useState(true);


    /*
    |--------------------------------------------------------------------------
    | Get Social Links / Contact Details
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const fetchDomainDetails = async () => {

            try {

                setContactLoading(true);

                const response =
                    await getDomainDetails();

                if (
                    response?.success &&
                    response?.data
                ) {

                    setDomainDetails(
                        response.data
                    );

                }

            } catch (error) {

                console.error(
                    "CONTACT DETAILS ERROR:",
                    error
                );

            } finally {

                setContactLoading(false);

            }

        };


        fetchDomainDetails();

    }, []);


    /*
    |--------------------------------------------------------------------------
    | Handle Input
    |--------------------------------------------------------------------------
    */

    const handleChange = (e) => {

        const {
            name,
            value
        } = e.target;

        setFormData({
            ...formData,
            [name]: value
        });

    };


    /*
    |--------------------------------------------------------------------------
    | Send Message To WhatsApp
    |--------------------------------------------------------------------------
    */

    const handleSubmit = async (e) => {

        e.preventDefault();


        if (!formData.name.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Name Required",
                text: "Please enter your name.",
                confirmButtonColor: "#0d6efd"
            });

            return;
        }


        if (!formData.email.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Email Required",
                text: "Please enter your email address.",
                confirmButtonColor: "#0d6efd"
            });

            return;
        }


        if (!formData.mobile.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Mobile Number Required",
                text: "Please enter your mobile number.",
                confirmButtonColor: "#0d6efd"
            });

            return;
        }


        if (!formData.message.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Message Required",
                text: "Please enter your message.",
                confirmButtonColor: "#0d6efd"
            });

            return;
        }


        /*
        |--------------------------------------------------------------------------
        | Get WhatsApp Number From API
        |--------------------------------------------------------------------------
        */

        const whatsappNumber =
            String(
                domainDetails?.whatsapp || ""
            ).replace(/\D/g, "");


        if (!whatsappNumber) {

            Swal.fire({
                icon: "error",
                title: "WhatsApp Unavailable",
                text:
                    "WhatsApp number is currently unavailable. Please try again later.",
                confirmButtonColor: "#0d6efd"
            });

            return;
        }


        try {

            setLoading(true);


            const whatsappMessage = `
Hello HomoeoAdda,

I want to contact you.

━━━━━━━━━━━━━━━━━━━━
CONTACT DETAILS
━━━━━━━━━━━━━━━━━━━━

Name: ${formData.name.trim()}

Email: ${formData.email.trim()}

Mobile: ${formData.mobile.trim()}

Subject: ${
                formData.subject.trim() ||
                "Not Provided"
            }

Message:
${formData.message.trim()}

━━━━━━━━━━━━━━━━━━━━

Thank you,
HomoeoAdda Website
            `.trim();


            const whatsappUrl =
                `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
                    whatsappMessage
                )}`;


            window.open(
                whatsappUrl,
                "_blank",
                "noopener,noreferrer"
            );


            setFormData({
                name: "",
                email: "",
                mobile: "",
                subject: "",
                message: ""
            });


            await Swal.fire({

                icon: "success",

                title: "Opening WhatsApp",

                text:
                    "Your message has been prepared in WhatsApp.",

                confirmButtonText: "Continue",

                confirmButtonColor: "#25D366"

            });


        } catch (error) {

            console.error(
                "CONTACT ERROR:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Something Went Wrong",

                text:
                    "Unable to open WhatsApp. Please try again."

            });

        } finally {

            setLoading(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Contact Data
    |--------------------------------------------------------------------------
    */

    const email =
        domainDetails?.email ||
        "homoeoadda001@gmail.com";

    const mobile =
        domainDetails?.mobile || "";

    const whatsapp =
        String(
            domainDetails?.whatsapp || ""
        ).replace(/\D/g, "");


    return (

        <>

            <Header />


            {/* =====================================================
                PREMIUM HERO
            ===================================================== */}

            <section
                style={{
                    position: "relative",
                    overflow: "hidden",
                    background:
                        "linear-gradient(135deg, #071a3d 0%, #0d47a1 50%, #1565c0 100%)",
                    padding: "90px 0 100px"
                }}
            >

                <div
                    style={{
                        position: "absolute",
                        width: "300px",
                        height: "300px",
                        borderRadius: "50%",
                        background:
                            "rgba(255,255,255,0.06)",
                        top: "-120px",
                        right: "-80px"
                    }}
                />

                <div
                    style={{
                        position: "absolute",
                        width: "220px",
                        height: "220px",
                        borderRadius: "50%",
                        background:
                            "rgba(255,255,255,0.05)",
                        bottom: "-100px",
                        left: "-70px"
                    }}
                />


                <div className="container position-relative">

                    <div className="row justify-content-center">

                        <div className="col-lg-8 text-center text-white">

                            <div
                                className="d-inline-flex align-items-center px-3 py-2 rounded-pill mb-4"
                                style={{
                                    background:
                                        "rgba(255,255,255,0.12)",
                                    border:
                                        "1px solid rgba(255,255,255,0.20)",
                                    backdropFilter:
                                        "blur(10px)"
                                }}
                            >

                                <i
                                    className="bi bi-headset me-2"
                                    style={{
                                        color: "#7dd3fc"
                                    }}
                                ></i>

                                <span
                                    className="fw-semibold"
                                    style={{
                                        fontSize: "14px",
                                        letterSpacing: "1px"
                                    }}
                                >
                                    GET IN TOUCH
                                </span>

                            </div>


                            <h1
                                className="fw-bold mb-3"
                                style={{
                                    fontSize:
                                        "clamp(36px, 5vw, 58px)",
                                    letterSpacing: "-1px"
                                }}
                            >
                                Contact{" "}
                                <span
                                    style={{
                                        color: "#7dd3fc"
                                    }}
                                >
                                    HomoeoAdda
                                </span>
                            </h1>


                            <p
                                className="mb-0 mx-auto"
                                style={{
                                    maxWidth: "680px",
                                    color:
                                        "rgba(255,255,255,0.78)",
                                    fontSize: "17px",
                                    lineHeight: "1.8"
                                }}
                            >
                                Have questions about our courses,
                                MCQs, premium papers or subscription
                                plans? Our team is here to help you.
                            </p>

                        </div>

                    </div>

                </div>

            </section>


            {/* =====================================================
                CONTACT SECTION
            ===================================================== */}

            <section
                style={{
                    background:
                        "linear-gradient(180deg, #f5f8fc 0%, #ffffff 100%)",
                    padding: "80px 0"
                }}
            >

                <div className="container">

                    <div className="row g-4 g-lg-5">


                        {/* =================================================
                            CONTACT INFORMATION
                        ================================================= */}

                        <div className="col-lg-5">

                            <div
                                className="h-100 p-4 p-md-5 rounded-4"
                                style={{
                                    background:
                                        "linear-gradient(145deg, #071a3d, #0d47a1)",
                                    boxShadow:
                                        "0 20px 60px rgba(13,71,161,0.20)",
                                    color: "#fff",
                                    position: "relative",
                                    overflow: "hidden"
                                }}
                            >

                                <div
                                    style={{
                                        position: "absolute",
                                        width: "180px",
                                        height: "180px",
                                        borderRadius: "50%",
                                        background:
                                            "rgba(255,255,255,0.05)",
                                        right: "-70px",
                                        top: "-60px"
                                    }}
                                />


                                <div className="position-relative">

                                    <span
                                        className="badge rounded-pill px-3 py-2 mb-3"
                                        style={{
                                            background:
                                                "rgba(255,255,255,0.12)",
                                            color: "#bfdbfe",
                                            border:
                                                "1px solid rgba(255,255,255,0.15)"
                                        }}
                                    >
                                        SUPPORT CENTER
                                    </span>


                                    <h2
                                        className="fw-bold mb-3"
                                        style={{
                                            fontSize: "32px"
                                        }}
                                    >
                                        Let's Talk
                                    </h2>


                                    <p
                                        className="mb-5"
                                        style={{
                                            color:
                                                "rgba(255,255,255,0.72)",
                                            lineHeight: "1.8"
                                        }}
                                    >
                                        Whether you need help with
                                        courses, MCQ papers,
                                        subscriptions or anything
                                        related to HomoeoAdda,
                                        feel free to contact us.
                                    </p>


                                    {/* EMAIL */}

                                    <div
                                        className="d-flex align-items-center mb-4"
                                    >

                                        <div
                                            className="d-flex align-items-center justify-content-center flex-shrink-0"
                                            style={{
                                                width: "52px",
                                                height: "52px",
                                                borderRadius: "15px",
                                                background:
                                                    "rgba(255,255,255,0.10)",
                                                border:
                                                    "1px solid rgba(255,255,255,0.12)"
                                            }}
                                        >

                                            <i
                                                className="bi bi-envelope"
                                                style={{
                                                    fontSize: "21px",
                                                    color: "#93c5fd"
                                                }}
                                            ></i>

                                        </div>


                                        <div className="ms-3">

                                            <div
                                                style={{
                                                    fontSize: "13px",
                                                    color:
                                                        "rgba(255,255,255,0.55)",
                                                    marginBottom: "3px"
                                                }}
                                            >
                                                EMAIL
                                            </div>

                                            <div
                                                className="fw-semibold"
                                                style={{
                                                    fontSize: "15px"
                                                }}
                                            >
                                                {contactLoading
                                                    ? "Loading..."
                                                    : email}
                                            </div>

                                        </div>

                                    </div>


                                    {/* PHONE */}

                                    <div
                                        className="d-flex align-items-center mb-4"
                                    >

                                        <div
                                            className="d-flex align-items-center justify-content-center flex-shrink-0"
                                            style={{
                                                width: "52px",
                                                height: "52px",
                                                borderRadius: "15px",
                                                background:
                                                    "rgba(255,255,255,0.10)",
                                                border:
                                                    "1px solid rgba(255,255,255,0.12)"
                                            }}
                                        >

                                            <i
                                                className="bi bi-telephone"
                                                style={{
                                                    fontSize: "21px",
                                                    color: "#86efac"
                                                }}
                                            ></i>

                                        </div>


                                        <div className="ms-3">

                                            <div
                                                style={{
                                                    fontSize: "13px",
                                                    color:
                                                        "rgba(255,255,255,0.55)",
                                                    marginBottom: "3px"
                                                }}
                                            >
                                                PHONE
                                            </div>

                                            {mobile ? (

                                                <a
                                                    href={`tel:${mobile}`}
                                                    className="text-white text-decoration-none fw-semibold"
                                                >
                                                    {mobile}
                                                </a>

                                            ) : (

                                                <span
                                                    className="text-white fw-semibold"
                                                >
                                                    Not Available
                                                </span>

                                            )}

                                        </div>

                                    </div>


                                    {/* WHATSAPP */}

                                    <div
                                        className="d-flex align-items-center mb-4"
                                    >

                                        <div
                                            className="d-flex align-items-center justify-content-center flex-shrink-0"
                                            style={{
                                                width: "52px",
                                                height: "52px",
                                                borderRadius: "15px",
                                                background:
                                                    "rgba(37,211,102,0.14)",
                                                border:
                                                    "1px solid rgba(37,211,102,0.20)"
                                            }}
                                        >

                                            <i
                                                className="bi bi-whatsapp"
                                                style={{
                                                    fontSize: "22px",
                                                    color: "#25D366"
                                                }}
                                            ></i>

                                        </div>


                                        <div className="ms-3">

                                            <div
                                                style={{
                                                    fontSize: "13px",
                                                    color:
                                                        "rgba(255,255,255,0.55)",
                                                    marginBottom: "3px"
                                                }}
                                            >
                                                WHATSAPP
                                            </div>

                                            {whatsapp ? (

                                                <a
                                                    href={`https://wa.me/${whatsapp}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-white text-decoration-none fw-semibold"
                                                >
                                                    Chat with us
                                                </a>

                                            ) : (

                                                <span
                                                    className="text-white fw-semibold"
                                                >
                                                    Not Available
                                                </span>

                                            )}

                                        </div>

                                    </div>




                                    <div
                                        className="mt-5 p-3 rounded-3"
                                        style={{
                                            background:
                                                "rgba(255,255,255,0.07)",
                                            border:
                                                "1px solid rgba(255,255,255,0.10)"
                                        }}
                                    >

                                        <div
                                            className="d-flex align-items-center"
                                        >

                                            <i
                                                className="bi bi-clock-history me-3"
                                                style={{
                                                    color: "#93c5fd",
                                                    fontSize: "20px"
                                                }}
                                            ></i>

                                            <div>

                                                <div
                                                    className="fw-semibold"
                                                    style={{
                                                        fontSize: "14px"
                                                    }}
                                                >
                                                    We're here to help
                                                </div>

                                                <div
                                                    style={{
                                                        color:
                                                            "rgba(255,255,255,0.55)",
                                                        fontSize: "12px"
                                                    }}
                                                >
                                                    Send us your query anytime
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* =================================================
                            CONTACT FORM
                        ================================================= */}

                        <div className="col-lg-7">

                            <div
                                className="bg-white rounded-4 p-4 p-md-5 h-100"
                                style={{
                                    border:
                                        "1px solid #e8edf5",
                                    boxShadow:
                                        "0 15px 50px rgba(15,23,42,0.08)"
                                }}
                            >

                                <div className="mb-4">

                                    <span
                                        className="text-primary fw-semibold"
                                        style={{
                                            fontSize: "13px",
                                            letterSpacing: "1px"
                                        }}
                                    >
                                        SEND A MESSAGE
                                    </span>


                                    <h2
                                        className="fw-bold mt-2 mb-2"
                                        style={{
                                            color: "#0f172a"
                                        }}
                                    >
                                        How can we help?
                                    </h2>


                                    <p
                                        className="text-muted mb-0"
                                        style={{
                                            lineHeight: "1.7"
                                        }}
                                    >
                                        Fill in the details below and
                                        we'll connect with you on
                                        WhatsApp.
                                    </p>

                                </div>


                                <form onSubmit={handleSubmit}>

                                    <div className="row g-4">


                                        {/* NAME */}

                                        <div className="col-md-6">

                                            <label className="form-label fw-semibold">
                                                Full Name
                                                <span className="text-danger ms-1">
                                                    *
                                                </span>
                                            </label>

                                            <div className="input-group">

                                                <span className="input-group-text bg-white">
                                                    <i className="bi bi-person text-primary"></i>
                                                </span>

                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control"
                                                    placeholder="Enter your name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    style={{
                                                        minHeight: "48px"
                                                    }}
                                                />

                                            </div>

                                        </div>


                                        {/* EMAIL */}

                                        <div className="col-md-6">

                                            <label className="form-label fw-semibold">
                                                Email Address
                                                <span className="text-danger ms-1">
                                                    *
                                                </span>
                                            </label>

                                            <div className="input-group">

                                                <span className="input-group-text bg-white">
                                                    <i className="bi bi-envelope text-primary"></i>
                                                </span>

                                                <input
                                                    type="email"
                                                    name="email"
                                                    className="form-control"
                                                    placeholder="Enter your email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    style={{
                                                        minHeight: "48px"
                                                    }}
                                                />

                                            </div>

                                        </div>


                                        {/* MOBILE */}

                                        <div className="col-md-6">

                                            <label className="form-label fw-semibold">
                                                Mobile Number
                                                <span className="text-danger ms-1">
                                                    *
                                                </span>
                                            </label>

                                            <div className="input-group">

                                                <span className="input-group-text bg-white">
                                                    <i className="bi bi-phone text-primary"></i>
                                                </span>

                                                <input
                                                    type="tel"
                                                    name="mobile"
                                                    className="form-control"
                                                    placeholder="Enter mobile number"
                                                    value={formData.mobile}
                                                    onChange={handleChange}
                                                    maxLength="10"
                                                    style={{
                                                        minHeight: "48px"
                                                    }}
                                                />

                                            </div>

                                        </div>


                                        {/* SUBJECT */}

                                        <div className="col-md-6">

                                            <label className="form-label fw-semibold">
                                                Subject
                                            </label>

                                            <div className="input-group">

                                                <span className="input-group-text bg-white">
                                                    <i className="bi bi-chat-square-text text-primary"></i>
                                                </span>

                                                <input
                                                    type="text"
                                                    name="subject"
                                                    className="form-control"
                                                    placeholder="Enter subject"
                                                    value={formData.subject}
                                                    onChange={handleChange}
                                                    style={{
                                                        minHeight: "48px"
                                                    }}
                                                />

                                            </div>

                                        </div>


                                        {/* MESSAGE */}

                                        <div className="col-12">

                                            <label className="form-label fw-semibold">
                                                Your Message
                                                <span className="text-danger ms-1">
                                                    *
                                                </span>
                                            </label>

                                            <textarea
                                                name="message"
                                                rows="6"
                                                className="form-control"
                                                placeholder="Write your message here..."
                                                value={formData.message}
                                                onChange={handleChange}
                                                style={{
                                                    resize: "vertical",
                                                    borderRadius: "12px"
                                                }}
                                            ></textarea>

                                        </div>


                                        {/* WHATSAPP NOTICE */}

                                        <div className="col-12">

                                            <div
                                                className="d-flex align-items-start p-3 rounded-3"
                                                style={{
                                                    background:
                                                        "#f0fdf4",
                                                    border:
                                                        "1px solid #bbf7d0"
                                                }}
                                            >

                                                <i
                                                    className="bi bi-whatsapp flex-shrink-0 me-3"
                                                    style={{
                                                        color: "#25D366",
                                                        fontSize: "21px"
                                                    }}
                                                ></i>

                                                <div>

                                                    <div
                                                        className="fw-semibold"
                                                        style={{
                                                            color:
                                                                "#166534",
                                                            fontSize: "14px"
                                                        }}
                                                    >
                                                        Message via WhatsApp
                                                    </div>

                                                    <div
                                                        style={{
                                                            color:
                                                                "#4d7c5b",
                                                            fontSize: "13px",
                                                            lineHeight: "1.5"
                                                        }}
                                                    >
                                                        Your entered details
                                                        will be automatically
                                                        added to a WhatsApp
                                                        message.
                                                    </div>

                                                </div>

                                            </div>

                                        </div>


                                        {/* SUBMIT */}

                                        <div className="col-12">

                                            <button
                                                type="submit"
                                                disabled={
                                                    loading ||
                                                    contactLoading
                                                }
                                                className="btn w-100 py-3 rounded-3 fw-bold text-white"
                                                style={{
                                                    background:
                                                        "linear-gradient(135deg, #0d6efd, #084298)",
                                                    border: "none",
                                                    boxShadow:
                                                        "0 8px 20px rgba(13,110,253,0.25)",
                                                    fontSize: "15px"
                                                }}
                                            >

                                                {loading ? (

                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                        ></span>

                                                        Opening WhatsApp...
                                                    </>

                                                ) : contactLoading ? (

                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                        ></span>

                                                        Loading...
                                                    </>

                                                ) : (

                                                    <>
                                                        <i
                                                            className="bi bi-whatsapp me-2"
                                                        ></i>

                                                        Send Message on WhatsApp

                                                        <i
                                                            className="bi bi-arrow-right ms-2"
                                                        ></i>
                                                    </>

                                                )}

                                            </button>

                                        </div>

                                    </div>

                                </form>

                            </div>

                        </div>

                    </div>

                </div>

            </section>


            {/* =====================================================
                BOTTOM CTA
            ===================================================== */}

            <section
                className="py-5"
                style={{
                    background: "#f8fafc"
                }}
            >

                <div className="container">

                    <div
                        className="rounded-4 p-4 p-md-5 text-center"
                        style={{
                            background:
                                "linear-gradient(135deg, #eff6ff, #f8fafc)",
                            border:
                                "1px solid #dbeafe"
                        }}
                    >

                        <div
                            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                            style={{
                                width: "58px",
                                height: "58px",
                                background: "#dbeafe",
                                color: "#0d6efd"
                            }}
                        >

                            <i
                                className="bi bi-chat-dots fs-4"
                            ></i>

                        </div>


                        <h3
                            className="fw-bold mb-2"
                            style={{
                                color: "#0f172a"
                            }}
                        >
                            Need quick assistance?
                        </h3>


                        <p className="text-muted mb-4">
                            Connect with our team directly on WhatsApp.
                        </p>


                        {whatsapp && (

                            <a
                                href={`https://wa.me/${whatsapp}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-success px-4 py-3 rounded-pill fw-semibold"
                            >

                                <i className="bi bi-whatsapp me-2"></i>

                                Chat on WhatsApp

                            </a>

                        )}

                    </div>

                </div>

            </section>


            <Footer />

        </>

    );

}


export default Contact;